function findByText(text, exact = false) {
	const els = document.querySelectorAll('span, p, label, h6, h5, h4, button, .MuiTypography-root')
	for (const el of els) {
		const content = el.textContent.trim().toLowerCase()
		if (exact ? content === text.toLowerCase() : content.includes(text.toLowerCase())) {
			return el
		}
	}
	return null
}

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	{
		type: 'intro',
		icon: 'diagram-project',
		title: ES ? 'Bienvenido a Mapeo personalizado' : 'Welcome to Custom Mapping',
		description: ES
			? 'El Mapeo personalizado te permite definir cómo se asignan los códigos ACRISS y las categorías de vehículos en función de criterios específicos como oficinas, países, sitios, proveedores, modelos de coche y características del vehículo. Crea mapeos uno a uno o súbelos en bloque mediante XLSX.'
			: 'Custom Mapping lets you define how ACRISS codes and vehicle categories are mapped based on specific criteria like offices, countries, sites, providers, car models, and vehicle features. Create mappings one by one or upload them in bulk via XLSX.',
	},
	{
		type: 'field',
		findTarget: () => {
			const el = findByText('Create custom ACRISS') || findByText('Create custom Category')
			if (el) {
				const btn = el.closest('button')
				if (btn?.parentElement) return btn.parentElement
			}
			return null
		},
		icon: 'toolbox',
		title: ES ? 'Botones de acción' : 'Action Buttons',
		description: ES
			? 'Tres acciones para cada tipo de mapeo. "Crear personalizado": abre un panel lateral para definir un nuevo mapeo con todos los criterios. "Subir XLSX": importación masiva de mapeos desde una hoja de cálculo con vista previa de validación. "Descargar ejemplo": obtén una plantilla XLSX para rellenar.'
			: 'Three actions for each mapping type. "Create custom": opens a side drawer to define a new mapping with all criteria. "Upload XLSX": bulk import mappings from a spreadsheet with validation preview. "Download Example": get a template XLSX file to fill in.',
		example: ES
			? '➕ Crear | 📄 Subir XLSX | 📥 Descargar ejemplo'
			: '➕ Create | 📄 Upload XLSX | 📥 Download Example',
	},
	{
		type: 'field',
		findTarget: () => {
			const papers = document.querySelectorAll('.MuiPaper-root, .MuiCard-root')
			for (const paper of papers) {
				if (!paper.textContent.includes('Custom ACRISS Mapping')) continue
				const rows = paper.querySelectorAll('table tbody tr')
				const hasData = Array.from(rows).some(r =>
					r.querySelectorAll('td').length >= 3 && !r.textContent.includes('no matching records')
				)
				if (hasData) return paper
			}
			const el = findByText('Custom ACRISS Mapping')
			if (el) {
				const paper = el.closest('.MuiPaper-root')
				if (paper) return paper
			}
			return null
		},
		icon: 'table-cells',
		title: ES ? 'Tabla de mapeo ACRISS' : 'ACRISS Mapping Table',
		description: ES
			? 'Todos tus mapeos ACRISS personalizados. Cada fila define una regla de mapeo con criterios: oficinas, países, sitios, código ACRISS, proveedores, modelo de coche, puertas, plazas, transmisión, A/C y quién es el propietario (usuario o empresa). Usa la búsqueda y los filtros de columna para encontrar mapeos específicos.'
			: 'All your custom ACRISS mappings. Each row defines a mapping rule with criteria: offices, countries, sites, the ACRISS code, providers, car model, doors, seats, transmission, A/C, and who owns it (user or company). Use search and column filters to find specific mappings.',
	},
	{
		type: 'field',
		findTarget: () => {
			const papers = document.querySelectorAll('.MuiPaper-root, .MuiCard-root')
			for (const paper of papers) {
				if (!paper.textContent.includes('Custom Categories Mapping')) continue
				const rows = paper.querySelectorAll('table tbody tr')
				const hasData = Array.from(rows).some(r =>
					r.querySelectorAll('td').length >= 3 && !r.textContent.includes('no matching records')
				)
				if (hasData) return paper
			}
			const el = findByText('Custom Categories Mapping')
			if (el) {
				const paper = el.closest('.MuiPaper-root')
				if (paper) return paper
			}
			return null
		},
		icon: 'tags',
		title: ES ? 'Tabla de mapeo de categorías' : 'Categories Mapping Table',
		description: ES
			? 'Misma estructura que ACRISS pero para categorías de vehículos. Define cómo se asignan las categorías en función de los mismos criterios: oficinas, países, sitios, proveedores, modelo de coche y características del vehículo. Los campos vacíos se tratan como "Cualquiera" (coincide con todo).'
			: 'Same structure as ACRISS but for vehicle categories. Define how categories are assigned based on the same criteria: offices, countries, sites, providers, car model, and vehicle features. Fields left empty are treated as "Any" (match all).',
	},
	{
		type: 'field',
		findTarget: () => {
			const icon = document.querySelector('.fa-pen') || document.querySelector('[data-icon="pen"]')
			if (icon) {
				const btn = icon.closest('button')
				if (btn?.parentElement) {
					const row = btn.parentElement
					if (row.children.length >= 2) return row
				}
				return btn
			}
			return null
		},
		skipIf: () => !document.querySelector('.fa-pen') && !document.querySelector('[data-icon="pen"]'),
		icon: 'pen-to-square',
		title: ES ? 'Editar y eliminar' : 'Edit & Delete',
		description: ES
			? 'Cada fila tiene botones de acción. Editar (lápiz): abre el panel lateral con todos los valores actuales precargados. Eliminar (papelera): borra el mapeo tras confirmación. Selecciona varias filas para eliminarlas en bloque usando la barra de herramientas que aparece.'
			: 'Each row has action buttons. Edit (pencil): opens the side drawer with all current values pre-filled. Delete (trash): removes the mapping after confirmation. Select multiple rows to delete them in bulk using the toolbar that appears.',
	},
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo listo!' : "You're All Set!",
		description: ES
			? 'Crea mapeos individualmente o súbelos en bloque mediante XLSX. Descarga primero la plantilla de ejemplo para ver el formato correcto. Los campos vacíos actúan como comodines ("Cualquiera"). Usa el panel de edición para modificar mapeos existentes, o la selección múltiple para eliminar varios a la vez.'
			: 'Create mappings individually or upload in bulk via XLSX. Download the example template first to see the correct format. Empty fields act as wildcards ("Any"). Use the edit drawer to modify existing mappings, or multi-select to delete several at once.',
	},
]
